import { useSnapshot } from "valtio";
import { configStore, viewBookingStore } from "../state/CommonState";
import { Box } from "@mui/material";
import { PricingDetailsCard } from "../mui-components/PricingDetailsCard";
import Utils from "../util/Utils";

function convertRate(e){
    let rate = 0;
    let volumeDiscount = 0.0;
    let erate = configStore.getExchangeRate(e.currency)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            console.log("unsiudcgftydt jhjhvhj jgjgh gcjc jgcjh jhgv hgf yvyg vv ")
            volumeDiscount = (e.total * erate)
            // if (volumeDiscount > 0) volumeDiscount *= -1
        } else {
            rate = parseFloat(e.total) * erate
        }
        return {rate,volumeDiscount};
}


function getChargesList(chargesList){
    let chargeList = [];
    chargesList.forEach(element => {
        if((+element.perCBM) !== 0 || (+element.perShipment) !== 0 || (+element.perTon) !== 0 || (+element.minimum) !== 0 || (+element.maximum) !== 0 || (+element.total) !== 0){
             if(element.onaccount==="On Your Account" ){
                 if(chargeList[0]){
                    chargeList[0].charges.push(element);
                 }else{
                    chargeList[0] = {account:"On Your Account",charges:[element],total:0.0,volumeDiscount:0.0,isDiscount:true}
                 }
                 chargeList[0].total += convertRate(element).rate;
                 chargeList[0].volumeDiscount = Math.abs(convertRate(element).volumeDiscount)
             }else if(element.onaccount==="Consignee's Account"){
                if(chargeList[1]){
                    chargeList[1].charges.push(element);
                 }else{
                    chargeList[1] = {account:"On Consignee Account",charges:[element],total:0.0,volumeDiscount:0.0,isDiscount:true}
                 }
                 chargeList[1].total += convertRate(element).rate;
                 chargeList[1].volumeDiscount = Math.abs(convertRate(element).volumeDiscount)
             }else if(element.onaccount?.startsWith('Ship')){
                if(chargeList[2]){
                    chargeList[2].charges.push(element);
                 }else{
                    chargeList[2] = {account:"On Shipper Account",charges:[element],total:0.0,volumeDiscount:0.0,isDiscount:true}
                 }
                 chargeList[2].total += convertRate(element).rate;
                 chargeList[2].volumeDiscount = Math.abs(convertRate(element).volumeDiscount)
             }
        }
    });
    return chargeList;
}


export function LCLBookingPricingDetail(){
    const {booking} = useSnapshot(viewBookingStore).current;
    const filteredChargesList = getChargesList(Utils.getChargeListFormatFromBooking(booking.contract));
    console.log("the value ehggtvvgjsdv cdkjvfkhefv ewfhjcefkhcf ",filteredChargesList);
    return <Box sx={{display:"flex",flexDirection:"row",width:"100%",gap:1,justifyContent:"center"}}>
      {filteredChargesList.map((charge)=><Box sx={{width:"30%", border: "1px solid #D4D4D4", borderRadius: "10px", paddingY: "8px", paddingX: "12px"}}><PricingDetailsCard title={charge.account} charge={charge}/></Box>)}
    </Box>
}


